module.exports = __webpack_public_path__ + "img/left-model.68400882.png";